import TagManager from "react-gtm-module";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    metrilo: any;
    metriloQueue: any[];
    omnisend: any;
  }
}

const tagManagerArgs = {
  gtmId: "GTM-P82Z52MF",
};

export const Tracking = () => {
  function initialize(): void {
    // if( process.env.NODE_ENV === 'development') {return}

    TagManager.initialize(tagManagerArgs);
  }

  function pageView(
    pageType: string,
    path: string,
    page_query: any,
    page_term: any,
    user: any,
    title: string,
    overrides: any,
    metriloConfig: any
  ): void {
    //  console.log('>>>pageView', pageType, title, overrides, metriloConfig);
    TagManager.dataLayer({
      dataLayer: {
        // Custom Dimensions outside EEC and with pageview
        event: "page_view", // GTM trigger to pull data from dataLayer
        page_type: pageType, // Values: Homepage | Category | Product | Cart | Checkout | Purchase | Stores | Help | About | 404 | Other (Values based on page type)
        site_lang: "en",
        page_path: path,
        full_URL: window.location.href,
        search_term: page_term || undefined,
        filters: page_query || undefined,
        user_id: user || undefined,
        title: title || "",
        ...overrides,
      },
    });
  }

  return {
    initialize,
    pageView,
  };
};

export default Tracking();
